module.exports = __webpack_public_path__ + "static/img/eyes.c4f7c77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/emotions/emoji/eyes.png
// module id = kVuY
// module chunks = 0